import { Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.jsx";
import { BrandProvider } from "../contexts/BrandContext.jsx";
import { resolveEntryRoute } from "../constants/routes.js";
import { lazyWithRetry } from "../utils/lazyWithRetry.js";
import PublicLandingPage from "./PublicLandingPage.jsx";
import LoginPage from "./LoginPage.jsx";
const Workspace = lazyWithRetry(() => import("./SharedGoalsWorkspace.jsx"), "워크스페이스");

export function EntryLoading() {
  return <div role="status" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--mpx-bg)", color: "var(--mpx-text-secondary)", fontSize: "var(--mpx-text-base)" }}>로딩 중...</div>;
}

// AuthProvider remains the sole session authority. The workspace bundle is requested
// only after verification; saved credentials are never treated as an authenticated session.
export default function EntryRouter() {
  const { loading, isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const entry = resolveEntryRoute({ pathname, isAuthenticated });
  if (loading) return <EntryLoading/>;
  if (!isAuthenticated) return entry === "landing" ? <PublicLandingPage/> : <LoginPage/>;
  if (entry === "home") return <Navigate to="/" replace/>;
  return <BrandProvider><Suspense fallback={<EntryLoading/>}><Workspace/></Suspense></BrandProvider>;
}
